import { all } from "redux-saga/effects";
import CamadaSaga from "./camada/sagas";
import PanoramaSaga from "./panorama/sagas";

export default all([CamadaSaga, PanoramaSaga]);
